module.exports = __webpack_public_path__ + "img/750000492_4.65a16e3a.jpg";